import { CreateUpdatePositionRequest } from '@src/main/modules/parameters/infrastructure/dto/createUpdatePositionRequest';
import { createPositionHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/PositionHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const createPositionUseCase = async (
  data: CreateUpdatePositionRequest,
  tokenProvider: TokenProvider,
) => {
  const repository = createPositionHttpRepository(tokenProvider);
  return await repository.create(data);
};
